import { createContext } from 'react';
import { MediaUploaderController } from './MediaUploaderController';
import { IMediaUploaderContext } from './models';

export const MediaUploaderContext = createContext<IMediaUploaderContext>({
  controller: new MediaUploaderController(),
  id: '',
  uploadFile: () => {},
});
